var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { Component } from "react";
import { borderDark, borderLight } from "../tokens.esm.js";
import Circle from "./Circle.esm.js";
import SpinningCircle from "./SpinningCircle.esm.js";
class ChartInfoPointsLegend extends Component {
  render() {
    var boxStyle = {
      position: "absolute",
      top: "15px",
      right: "25px",
      maxWidth: "50%",
      backgroundColor: borderLight,
      border: `1px solid ${borderDark}`,
      textAlign: "left",
      fontSize: "10px",
      fontFamily: this.props.fontFamily
    }, info = this.props.activeInfoPoint ? /* @__PURE__ */ jsx("div", { style: boxStyle, className: "linechart-legend", children: /* @__PURE__ */ jsx("table", { children: /* @__PURE__ */ jsx("tbody", { children: /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsxs("td", { style: {
      padding: "5px"
    }, children: [
      /* @__PURE__ */ jsx("span", { className: "zsg-icon-circle", style: {
        paddingRight: "5px",
        color: this.props.activeInfoPoint.color,
        fontSize: "10px"
      } }),
      this.props.activeInfoPoint.info
    ] }) }) }) }) }) : null;
    return info;
  }
}
__publicField(ChartInfoPointsLegend, "propTypes", {
  activeInfoPoint: PropTypes.object,
  color: PropTypes.string,
  fontFamily: PropTypes.string
});
class ChartInfoPoints extends Component {
  render() {
    var props = this.props, infoPointCircles = [];
    if (props.infoPoints) {
      props.infoPoints.forEach(function(point) {
        if (point.active) {
          infoPointCircles.push(/* @__PURE__ */ jsx(SpinningCircle, { cx: props.xScale(point.x), cy: props.yScale(point.y), r: 10, color: point.color }, `${point.x}info`));
        }
        infoPointCircles.push(/* @__PURE__ */ jsx(Circle, { cx: props.xScale(point.x), cy: props.yScale(point.y), r: 5, fill: point.color }, point.x));
      });
    }
    return /* @__PURE__ */ jsx("g", { children: infoPointCircles });
  }
}
__publicField(ChartInfoPoints, "propTypes", {
  infoPoints: PropTypes.array,
  xScale: PropTypes.func,
  yScale: PropTypes.func,
  color: PropTypes.string
});
export {
  ChartInfoPoints,
  ChartInfoPointsLegend
};
